/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Invalid_SubscriptionInputs */

const en_plan_invalid_subscription = /** @type {(inputs: Plan_Invalid_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid Subscription`)
};

const es_plan_invalid_subscription = /** @type {(inputs: Plan_Invalid_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción inválida`)
};

/**
* | output |
* | --- |
* | "Invalid Subscription" |
*
* @param {Plan_Invalid_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_invalid_subscription = /** @type {((inputs?: Plan_Invalid_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Invalid_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_invalid_subscription(inputs)
	return en_plan_invalid_subscription(inputs)
});